
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export const Hero = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  
  return (
    <div className="relative min-h-screen flex items-center">
      <div className="absolute inset-0 bg-[#0077bb]" />
      <div className="absolute inset-0 bg-grid-white/[0.2] bg-grid-8" />
      
      <div className="absolute bottom-0 left-0 w-full overflow-hidden">
        <svg
          viewBox="0 0 1440 220"
          className="relative w-full h-[120px] lg:h-[220px]"
          preserveAspectRatio="none"
        >
          <path
            fill="#F9FAFB"
            fillOpacity="1"
            d="M0,160L48,144C96,128,192,96,288,90.7C384,85,480,107,576,128C672,149,768,171,864,165.3C960,160,1056,128,1152,117.3C1248,107,1344,117,1392,122.7L1440,128L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
          ></path>
        </svg>
      </div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="text-left animate-fade-in">
            <h1 className="text-4xl sm:text-6xl font-bold text-white mb-6">
              {t('hero.title')}
            </h1>
            <p className="text-xl text-white/90 mb-8 leading-relaxed">
              {t('hero.description')}
            </p>
            <div className="flex space-x-4">
              <button 
                onClick={() => navigate("/request-demo")}
                className="bg-white text-[#0077bb] px-8 py-3 rounded-lg font-semibold hover:bg-white/90 transition-colors"
              >
                {t('hero.getStarted')}
              </button>
              <button 
                onClick={() => {
                  navigate("/learn-more");
                  window.scrollTo(0, 0);
                }}
                className="border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white/10 transition-colors"
              >
                {t('hero.learnMore')}
              </button>
            </div>
          </div>
          
          <div className="relative h-[450px] sm:h-[400px] lg:h-[500px] w-full animate-fade-in" style={{ animationDelay: "0.2s" }}>
            <img
              src="https://dynamico.cloud/assets/img/Tools.gif"
              alt="Dynamico Tools"
              className="rounded-lg w-full h-full object-contain sm:object-cover object-center"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
